import { SelectItem } from 'types/selectLists'
import { OrderTypeId } from 'types/order'

export default class OrderTypes {
  static getForExternalUser(availableOrderTypes: Array<number | string> | null, allTypes: SelectItem[]) {
    const types = [...allTypes]

    if (!availableOrderTypes) return types

    const allowedTypeIds = new Set(availableOrderTypes.map((typeId) => String(typeId)))

    return types?.filter((type) => allowedTypeIds.has(String(type.id))).map((type) => ({ ...type, isHidden: false }))
  }

  static getForInternalUser(allTypes: SelectItem[]) {
    const types = [...allTypes]

    const counterpartyAndTsId = types.findIndex((type) => Number(type.id) === Number(OrderTypeId.COUNTERPARTY_BORROWER_AND_TS))

    if (counterpartyAndTsId !== -1) {
      types[counterpartyAndTsId].isHidden = false
    }

    return types
  }
}
